import { Card, CardBody, Col, Row } from "reactstrap";
import AdditiveBorder from "./AdditiveBorder";
import AdditiveRadius from "./AdditiveRadius";
import SubtractiveBorder from "./SubtractiveBorder";
import { BordersAndDisplaysTitle } from "../../../../constants";
import { BordersAndDisplaySubTitle } from "../../../../data/uiKits/HelperClasses";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const BordersAndDisplays = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={BordersAndDisplaysTitle} span={BordersAndDisplaySubTitle} />
        <CardBody>
          <Row className="g-3">
            <AdditiveBorder />
            <SubtractiveBorder />
            <AdditiveRadius />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BordersAndDisplays;
